import Vue from 'vue';
import { Module } from 'vuex';
import { RootState } from '@/types/store';

export interface GameRankState {
    rank: {
        [key: string]: ListWrap<Game.Rank> & ListReq & { self: Game.Rank, cold_time: number },
    };
}

const m: Module<GameRankState, RootState> = {
    namespaced: true,
    state: {
        rank: {},
    },
    mutations: {
        initRank(state, { key }) {
            Vue.set(state.rank, key, {
                list: [],
                loaded: false,
                req: false,
                self: null,
                cold_time: null,
            });
        },
        setRank(state, { key, list, offset }) {
            list.forEach((ele: Game.Rank, idx: number) => {
                Vue.set(state.rank[key].list, offset + idx, ele);
            });
        },
        setReq(state, { key, req }) {
            state.rank[key].req = req;
        },
        setLoaded(state, { key, loaded }) {
            state.rank[key].loaded = loaded;
        },
        setSelf(state, { key, self, cold_time }) {
            state.rank[key].self = self;
            state.rank[key].cold_time = cold_time;
        },
    },
    actions: {
        async getRanks({ state, commit }, { key, offset, count, activityId, type, forceUpdate }) {
            let wrap = state.rank[key];
            if (!wrap || (forceUpdate && offset === 0)) {
                commit('initRank', { key });
                wrap = state.rank[key];
            }
            if (wrap.loaded || wrap.req) {
                return;
            }
            commit('setReq', { key, req: true });
            const res = await Vue.axios.get(`/api/v1/activity_match_rank/${type}`, {
                params: {
                    activity_id: activityId, offset, count,
                },
            });
            commit('setReq', { key, req: false });
            const rdata = res.data;
            if (rdata.status === 0) {
                const list = rdata.data.list;
                commit('setRank', {
                    offset, list, key,
                });
                commit('setSelf', {
                    key, self: rdata.data.self, cold_time: rdata.data.cold_time,
                });
                if (list.length < count) {
                    commit('setLoaded', { key, loaded: true });
                }
            }
            return rdata;
        },
    },
};

export default m;
